import { api } from "../Apis/interceptor";

export const getSeq = function (cust_id) {
  return api.get("/api/v1/OrganisationId/" + cust_id);
};
export const create = function (orgData) {
  return api.post("/api/v1/organisations/", orgData);
};
export const multiDelete = function (ids, cust_id) {
  return api.delete("/api/v1/organisationMultiDelete", {
    params: {
      id: ids,
      cust_id: cust_id,
    },
  });
};
export const filter = function (
  skip,
  limit,
  cust_id,
  branch,
  pattern,
  sortBy,
  orderBy,
  filterData,
  searchVal
) {
  pattern = pattern == "All" ? "" : pattern;
  return api.get("/api/v1/organisation_filter", {
    params: {
      skip: skip,
      limit: limit,
      cust_id: cust_id,
      branchId: branch.branch_id,
      branchKey: branch.branch_key,
      pattern: pattern,
      sortBy: sortBy,
      orderBy: orderBy,
      filterBranch: JSON.stringify(filterData.branch_id),
      organisation_classification: JSON.stringify(
        filterData.organisation_classification
      ),
      organisation_type: JSON.stringify(filterData.organisation_type),
      searchVal: searchVal,
    },
  });
};
export const get = function (id, cust_id, branch) {
  return api.get(
    "/api/v1/organisations/" +
      id +
      "/" +
      cust_id +
      "/" +
      branch.branch_id +
      "/" +
      branch.branch_key
  );
};
export const saveOrganisationAddress = function (
  id,
  cust_id,
  organisationAddress
) {
  return api.put(
    "/api/v1/saveOrganisationAddress/" + id + "/" + cust_id,
    organisationAddress
  );
};
export const updateOrganisationTeam = function (id, cust_id, organisationTeam) {
  return api.put(
    "/api/v1/updateOrganisationTeam/" + id + "/" + cust_id,
    organisationTeam
  );
};
export const getOrganisationContactList = function (
  id,
  cust_id,
  skip,
  limit,
  searchOrganisationByContact
) {
  return api.get("/api/v1/getOrganisationContactList", {
    params: {
      id: id,
      cust_id: cust_id,
      skip: skip,
      limit: limit,
      searchOrganisationByContact: searchOrganisationByContact,
    },
  });
};

//for opp stakeholder
export const getOrgTeam = function (id, cust_id) {
  return api.get("/api/v1/getOrgTeam/" + id + "/" + cust_id);
};
export const getOrgTeamAddress = function (id, cust_id) {
  return api.get("/api/v1/getOrgTeamAddress/" + id + "/" + cust_id);
};

export const addNewMember = function (
  opp_id,
  org_id,
  org_name,
  cust_id,
  index,
  addNewForm
) {
  return api.put(
    "/api/v1/addNewMember/" +
      opp_id +
      "/" +
      org_id +
      "/" +
      org_name +
      "/" +
      cust_id +
      "/" +
      index,
    addNewForm
  );
};

export const updateTeamMember = function (
  opp_id,
  org_id,
  cust_id,
  editTeamMemForm
) {
  return api.put(
    "/api/v1/updateTeamMember/" + opp_id + "/" + org_id + "/" + cust_id,
    editTeamMemForm
  );
};

export const editUpdateOrganisationTeam = function (
  id,
  cust_id,
  editOrganisationContact
) {
  return api.put(
    "/api/v1/editUpdateOrganisationTeam/" + id + "/" + cust_id,
    editOrganisationContact
  );
};
export const deleteOrganisationTeam = function (id, cust_id, orgTeam_Id) {
  return api.put(
    "/api/v1/deleteOrganisationTeam/" + id + "/" + cust_id + "/" + orgTeam_Id
  );
};

export const getOrganisationAddressList = function (
  id,
  cust_id,
  add_skip,
  add_limit,
  searchOrganisationByAddress
) {
  return api.get("/api/v1/getOrganisationAddressList", {
    params: {
      id: id,
      cust_id: cust_id,
      skip: add_skip,
      limit: add_limit,
      searchOrganisationByAddress: searchOrganisationByAddress,
    },
  });
};

export const addOrganisationAddress = function (
  id,
  cust_id,
  organisation_name,
  organisationAddressForm
) {
  return api.put(
    "/api/v1/addOrganisationAddress/" +
      id +
      "/" +
      cust_id +
      "/" +
      organisation_name,
    organisationAddressForm
  );
};

export const editUpdateOrganisationAddress = function (
  id,
  cust_id,
  isAssociated,
  editClientAddressForm
) {
  return api.put(
    "/api/v1/editUpdateOrganisationAddress/" +
      id +
      "/" +
      cust_id +
      "/" +
      isAssociated,
    editClientAddressForm
  );
};

export const deleteOrganisationAddress = function (
  id,
  cust_id,
  orgAddress_Id,
  isAssociated
) {
  return api.put(
    "/api/v1/deleteOrganisationAddress/" +
      id +
      "/" +
      cust_id +
      "/" +
      orgAddress_Id +
      "/" +
      isAssociated
  );
};

export const getPrevious = function (id, cust_id) {
  return api.get("/api/v1/organisationPrev/" + id + "/" + cust_id);
};
export const getNext = function (id, cust_id) {
  return api.get("/api/v1/organisationNext/" + id + "/" + cust_id);
};
export const update = function (id, orgData) {
  return api.put("/api/v1/organisations/" + id, orgData);
};

export const exportOrgContact = function (id, cust_id, token) {
  // $window.open(
  //   "/api/v1/exportOrgContact?token=" +
  //     token +
  //     "&org_id=" +
  //     id +
  //     "&cust_id=" +
  //     cust_id
  // );
};

export const allOrg = function (cust_id, branch) {
  return api.get("/api/v1/getAllOrganisations", {
    params: {
      cust_id: cust_id,
      branchId: branch.branch_id,
      branchKey: branch.branch_key,
    },
  });
};
